import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editInstallerNotesPromise, EditInstallerNotesPromiseParam } from 'src/utils/api';
import { useNotification } from 'src/hooks/use-notification';
import { QUERY_KEY_MAP } from 'src/constants/query-key';
import { clearInstallerLocalNotes } from 'src/components/OrgBrowser/DeviceViewer/InstallerNotes/installer-notes-store';

export const useEditInstallerNotes = () => {
  const queryClient = useQueryClient();
  const { enqueueSuccessNotification, enqueueErrorNotification } = useNotification();

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useEditInstallerNotes],
    mutationFn: editInstallerNotesPromise,
  });

  const editInstallerNotesAsync = async (param: EditInstallerNotesPromiseParam) => {
    try {
      await mutateAsync(param);
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useGetInstallerNotes, param.display_id],
      });

      clearInstallerLocalNotes();

      enqueueSuccessNotification('Installer Notes successfully saved.');
    } catch (e) {
      console.error(e);
      enqueueErrorNotification('Something went wrong while saving Installer Notes.');
    }
  };

  return {
    editInstallerNotesAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
